import { Component, ElementRef, Input } from '@angular/core';
import { icons } from './icons';

@Component({
  standalone: false,
  selector: 'm-icons',
  templateUrl: './icons.component.html',
  styleUrls: [],
})
export class IconsComponent {
  constructor(private element: ElementRef) {}

  @Input()
  set name(iconName: string) {
    this.element.nativeElement.innerHTML = icons[iconName] || null;
  }
}
